// extracted by mini-css-extract-plugin
module.exports = {"insightIconsWrapper":"GtsaPlMR","disabled":"Jb2NHsiE","styledImg":"JnE7qWF3"};